import { SPECIALFUNCUW_INIT_LOADING, SPECIALFUNCUW_INIT_SUCCESS, SPECIALFUNCUW_INIT_FAIL,
  RISK_SURVEY_NEW_MODE, RISK_SURVEY_REVIEW_MODE, RISK_SURVEY_QUERY_MODE, RISK_SURVEY_ENDORSEMENT_MODE, RISK_SURVEY_MASTER,
  RISK_SURVEY_DETAILS, RISK_SURVEY_TAB, RISK_SURVEY_INIT_LOADING, RISK_SURVEY_INIT_SUCCESS, RISK_SURVEY_INIT_FAIL,
  RESET_RISK_SURVEY_MASTER, RESET_RISK_SURVEY_DETAILS } from '@/store/types'

export const specialFuncUW = {
  [SPECIALFUNCUW_INIT_LOADING](state) {
    state.specialFuncUWSettings.init = 0
    state.specialFuncUWSettings.initErr = []
    state.specialFuncUWSettings.menu = {}
  },
  [SPECIALFUNCUW_INIT_SUCCESS](state, data) {
    state.specialFuncUWSettings.init = 1
    state.specialFuncUWSettings.initErr = []
    state.specialFuncUWSettings.menu = data.menu
  },
  [SPECIALFUNCUW_INIT_FAIL](state, error) {
    state.specialFuncUWSettings.init = 2
    state.specialFuncUWSettings.initErr = error
    state.specialFuncUWSettings.menu = {}
  },
  [RISK_SURVEY_INIT_LOADING](state) {
    state.specialFuncUWSettings.riskSurveySettings.menu.init = 0
    state.specialFuncUWSettings.riskSurveySettings.initErr = []
    state.specialFuncUWSettings.riskSurveySettings.menu = {}
  },
  [RISK_SURVEY_INIT_SUCCESS](state, data) {
    state.specialFuncUWSettings.riskSurveySettings.init = 1
    state.specialFuncUWSettings.riskSurveySettings.initErr = []
    state.specialFuncUWSettings.riskSurveySettings.menu = data.menu
  },
  [RISK_SURVEY_INIT_FAIL](state, error) {
    state.specialFuncUWSettings.riskSurveySettings.init = 2
    state.specialFuncUWSettings.riskSurveySettings.initErr = error
    state.specialFuncUWSettings.riskSurveySettings.menu = {}
  },
  [RISK_SURVEY_NEW_MODE](state) {
    state.specialFuncUWSettings.riskSurveyMode = 'New'
  },
  [RISK_SURVEY_REVIEW_MODE](state) {
    state.specialFuncUWSettings.riskSurveyMode = 'Review'
  },
  [RISK_SURVEY_QUERY_MODE] (state) {
    state.specialFuncUWSettings.riskSurveyMode = 'Query'
  },
  [RISK_SURVEY_ENDORSEMENT_MODE](state) {
    state.specialFuncUWSettings.riskSurveyMode = 'Endorsement'
  },
  [RISK_SURVEY_TAB](state, data) {
    state.specialFuncUWSettings.riskSurveyTab = data
  },
  [RISK_SURVEY_MASTER](state, data) {
    state.specialFuncUWSettings.riskSurveyMaster.survNo = data.survNo
    state.specialFuncUWSettings.riskSurveyMaster.verCnt = data.verCnt
    state.specialFuncUWSettings.riskSurveyMaster.survId = data.survId
    state.specialFuncUWSettings.riskSurveyMaster.survDate = data.survDate
    state.specialFuncUWSettings.riskSurveyMaster.polNo = data.polNo
    state.specialFuncUWSettings.riskSurveyMaster.insdName = data.insdName
    state.specialFuncUWSettings.riskSurveyMaster.bldgNo = data.bldgNo
    state.specialFuncUWSettings.riskSurveyMaster.unitNo = data.unitNo
    state.specialFuncUWSettings.riskSurveyMaster.addr1 = data.addr1
    state.specialFuncUWSettings.riskSurveyMaster.addr2 = data.addr2
    state.specialFuncUWSettings.riskSurveyMaster.addr3 = data.addr3
    state.specialFuncUWSettings.riskSurveyMaster.addr4 = data.addr4
    state.specialFuncUWSettings.riskSurveyMaster.postCode = data.postCode
    state.specialFuncUWSettings.riskSurveyMaster.survType = data.survType
    state.specialFuncUWSettings.riskSurveyMaster.extPhoto = data.extPhoto
    state.specialFuncUWSettings.riskSurveyMaster.intPhoto = data.intPhoto
    state.specialFuncUWSettings.riskSurveyMaster.plans = data.plans
    state.specialFuncUWSettings.riskSurveyMaster.adjUnit = data.adjUnit
    state.specialFuncUWSettings.riskSurveyMaster.contactName = data.contactName
    state.specialFuncUWSettings.riskSurveyMaster.telNo = data.telNo
    state.specialFuncUWSettings.riskSurveyMaster.nxtSurvBy = data.nxtSurvBy
    state.specialFuncUWSettings.riskSurveyMaster.updDate = data.updDate
    state.specialFuncUWSettings.riskSurveyMaster.recomComp = data.recomComp
    state.specialFuncUWSettings.riskSurveyMaster.remarks = data.remarks
    state.specialFuncUWSettings.riskSurveyMaster.uwIdConv = data.uwIdConv
    state.specialFuncUWSettings.riskSurveyMaster.nxtSurvDate = data.nxtSurvDate
  },
  [RISK_SURVEY_DETAILS](state, data) {
    state.specialFuncUWSettings.riskSurveyDetails.survNo = data.survNo
    state.specialFuncUWSettings.riskSurveyDetails.verCnt = data.verCnt
    state.specialFuncUWSettings.riskSurveyDetails.survDetType = data.survDetType
    if (data.survDetType === 'construction') {
      state.specialFuncUWSettings.riskSurveyDetails.constnCls = data.constnCls
      state.specialFuncUWSettings.riskSurveyDetails.yrBlt = data.yrBlt
      state.specialFuncUWSettings.riskSurveyDetails.preWar = data.preWar
      state.specialFuncUWSettings.riskSurveyDetails.refurbish = data.refurbish
      state.specialFuncUWSettings.riskSurveyDetails.wall = data.wall
      state.specialFuncUWSettings.riskSurveyDetails.roof = data.roof
      state.specialFuncUWSettings.riskSurveyDetails.floor = data.floor
      state.specialFuncUWSettings.riskSurveyDetails.stairs = data.stairs
      state.specialFuncUWSettings.riskSurveyDetails.noOpen = data.noOpen
      state.specialFuncUWSettings.riskSurveyDetails.noFireChkDoor = data.noFireChkDoor
      state.specialFuncUWSettings.riskSurveyDetails.constnType = data.constnType
      state.specialFuncUWSettings.riskSurveyDetails.extn = data.extn
      state.specialFuncUWSettings.riskSurveyDetails.extnConstn = data.extnConstn
      state.specialFuncUWSettings.riskSurveyDetails.noUnitTerr = data.noUnitTerr
      state.specialFuncUWSettings.riskSurveyDetails.occpnTerr = data.occpnTerr
      state.specialFuncUWSettings.riskSurveyDetails.noUnitHr = data.noUnitHr
      state.specialFuncUWSettings.riskSurveyDetails.occpnHr = data.occpnHr
      state.specialFuncUWSettings.riskSurveyDetails.strataTitle = data.strataTitle
      state.specialFuncUWSettings.riskSurveyDetails.nearBldg = data.nearBldg
      state.specialFuncUWSettings.riskSurveyDetails.adjUnitOccpn = data.adjUnitOccpn
      state.specialFuncUWSettings.riskSurveyDetails.constnRemarks = data.constnRemarks
    } else if (data.survDetType === 'surroundings') {
      state.specialFuncUWSettings.riskSurveyDetails.fencedUp = data.fencedUp
      state.specialFuncUWSettings.riskSurveyDetails.securGrd = data.securGrd
      state.specialFuncUWSettings.riskSurveyDetails.onSlope = data.onSlope
      state.specialFuncUWSettings.riskSurveyDetails.retStrc = data.retStrc
      state.specialFuncUWSettings.riskSurveyDetails.river = data.river
      state.specialFuncUWSettings.riskSurveyDetails.floodProne = data.floodProne
      state.specialFuncUWSettings.riskSurveyDetails.surrRemarks = data.surrRemarks
    } else if (data.survDetType === 'lighting') {
      state.specialFuncUWSettings.riskSurveyDetails.wiringType = data.wiringType
      state.specialFuncUWSettings.riskSurveyDetails.cbType = data.cbType
      state.specialFuncUWSettings.riskSurveyDetails.noGen = data.noGen
      state.specialFuncUWSettings.riskSurveyDetails.ltgRemarks = data.ltgRemarks
    } else if (data.survDetType === 'firePrevention') {
      state.specialFuncUWSettings.riskSurveyDetails.extType = data.extType
      state.specialFuncUWSettings.riskSurveyDetails.noExt = data.noExt
      state.specialFuncUWSettings.riskSurveyDetails.inspDate = data.inspDate
      state.specialFuncUWSettings.riskSurveyDetails.noHoseReel = data.noHoseReel
      state.specialFuncUWSettings.riskSurveyDetails.spr = data.spr
      state.specialFuncUWSettings.riskSurveyDetails.smokeDet = data.smokeDet
      state.specialFuncUWSettings.riskSurveyDetails.fireAlrm = data.fireAlrm
      state.specialFuncUWSettings.riskSurveyDetails.dryRiser = data.dryRiser
      state.specialFuncUWSettings.riskSurveyDetails.wetRiser = data.wetRiser
      state.specialFuncUWSettings.riskSurveyDetails.hydrant = data.hydrant
      state.specialFuncUWSettings.riskSurveyDetails.fireDrill = data.fireDrill
      state.specialFuncUWSettings.riskSurveyDetails.nearFireSt = data.nearFireSt
      state.specialFuncUWSettings.riskSurveyDetails.firePrevRemarks = data.firePrevRemarks
    } else if (data.survDetType === 'management') {
      state.specialFuncUWSettings.riskSurveyDetails.clean = data.clean
      state.specialFuncUWSettings.riskSurveyDetails.layout = data.layout
      state.specialFuncUWSettings.riskSurveyDetails.vent = data.vent
      state.specialFuncUWSettings.riskSurveyDetails.smokeReg = data.smokeReg
      state.specialFuncUWSettings.riskSurveyDetails.wasteDisp = data.wasteDisp
      state.specialFuncUWSettings.riskSurveyDetails.wasteDispFreq = data.wasteDispFreq
      state.specialFuncUWSettings.riskSurveyDetails.mgmtRemarks = data.mgmtRemarks
    } else if (data.survDetType === 'interestInsured') {
      state.specialFuncUWSettings.riskSurveyDetails.insdBldg = data.insdBldg
      state.specialFuncUWSettings.riskSurveyDetails.insdCont = data.insdCont
      state.specialFuncUWSettings.riskSurveyDetails.insdPlt = data.insdPlt
      state.specialFuncUWSettings.riskSurveyDetails.insdRawMat = data.insdRawMat
      state.specialFuncUWSettings.riskSurveyDetails.insdGoods = data.insdGoods
      state.specialFuncUWSettings.riskSurveyDetails.insdPackMat = data.insdPackMat
    } else if (data.survDetType === 'occupation') {
      state.specialFuncUWSettings.riskSurveyDetails.occpnCls = data.occpnCls
      state.specialFuncUWSettings.riskSurveyDetails.goodsType = data.goodsType
      state.specialFuncUWSettings.riskSurveyDetails.goodsFlam = data.goodsFlam
      state.specialFuncUWSettings.riskSurveyDetails.packType = data.packType
      state.specialFuncUWSettings.riskSurveyDetails.storeArr = data.storeArr
      state.specialFuncUWSettings.riskSurveyDetails.stacksHgt = data.stacksHgt
      state.specialFuncUWSettings.riskSurveyDetails.whsType = data.whsType
      state.specialFuncUWSettings.riskSurveyDetails.othTent = data.othTent
      state.specialFuncUWSettings.riskSurveyDetails.part = data.part
      state.specialFuncUWSettings.riskSurveyDetails.partType = data.partType
      state.specialFuncUWSettings.riskSurveyDetails.othTentGoods = data.othTentGoods
      state.specialFuncUWSettings.riskSurveyDetails.occpnRemarks = data.occpnRemarks
    } else if (data.survDetType === 'fireAttachment') {
      state.specialFuncUWSettings.riskSurveyDetails.fireAttchRemarks = data.fireAttchRemarks
    } else if (data.survDetType === 'stockDescription') {
      state.specialFuncUWSettings.riskSurveyDetails.stkType = data.stkType
      state.specialFuncUWSettings.riskSurveyDetails.stkVal = data.stkVal
      state.specialFuncUWSettings.riskSurveyDetails.highVal = data.highVal
      state.specialFuncUWSettings.riskSurveyDetails.invRec = data.invRec
    } else if (data.survDetType === 'premisesDescription') {
      state.specialFuncUWSettings.riskSurveyDetails.onPrem = data.onPrem
      state.specialFuncUWSettings.riskSurveyDetails.noOnPrem = data.noOnPrem
      state.specialFuncUWSettings.riskSurveyDetails.hrsEmpty = data.hrsEmpty
      state.specialFuncUWSettings.riskSurveyDetails.alrmType = data.alrmType
      state.specialFuncUWSettings.riskSurveyDetails.alrmConn = data.alrmConn
      state.specialFuncUWSettings.riskSurveyDetails.wtchmen = data.wtchmen
      state.specialFuncUWSettings.riskSurveyDetails.wtchmenArmd = data.wtchmenArmd
      state.specialFuncUWSettings.riskSurveyDetails.wtchmenHrs = data.wtchmenHrs
      state.specialFuncUWSettings.riskSurveyDetails.premRemarks = data.premRemarks
    } else if (data.survDetType === 'entrance') {
      state.specialFuncUWSettings.riskSurveyDetails.mainEntDrMat = data.mainEntDrMat
      state.specialFuncUWSettings.riskSurveyDetails.mainEntProt = data.mainEntProt
      state.specialFuncUWSettings.riskSurveyDetails.mainEntLock = data.mainEntLock
      state.specialFuncUWSettings.riskSurveyDetails.othEntDrMat = data.othEntDrMat
      state.specialFuncUWSettings.riskSurveyDetails.othEntProt = data.othEntProt
      state.specialFuncUWSettings.riskSurveyDetails.othEntLock = data.othEntLock
      state.specialFuncUWSettings.riskSurveyDetails.windMat = data.windMat
      state.specialFuncUWSettings.riskSurveyDetails.windProt = data.windProt
      state.specialFuncUWSettings.riskSurveyDetails.windLock = data.windLock
      state.specialFuncUWSettings.riskSurveyDetails.entRemarks = data.entRemarks
    } else if (data.survDetType === 'safeRoom') {
      state.specialFuncUWSettings.riskSurveyDetails.safeMake = data.safeMake
      state.specialFuncUWSettings.riskSurveyDetails.safeDim = data.safeDim
      state.specialFuncUWSettings.riskSurveyDetails.safeLock = data.safeLock
      state.specialFuncUWSettings.riskSurveyDetails.safeConcld = data.safeConcld
      state.specialFuncUWSettings.riskSurveyDetails.lossRemarks = data.lossRemarks
      state.specialFuncUWSettings.riskSurveyDetails.remarks = data.remarks
    } else if (data.survDetType === 'burglaryAttachment') {
      state.specialFuncUWSettings.riskSurveyDetails.burgRemarks = data.burgRemarks
    } else {
      state.specialFuncUWSettings.riskSurveyDetails.constnCls = data.constnCls
      state.specialFuncUWSettings.riskSurveyDetails.yrBlt = data.yrBlt
      state.specialFuncUWSettings.riskSurveyDetails.preWar = data.preWar
      state.specialFuncUWSettings.riskSurveyDetails.refurbish = data.refurbish
      state.specialFuncUWSettings.riskSurveyDetails.wall = data.wall
      state.specialFuncUWSettings.riskSurveyDetails.roof = data.roof
      state.specialFuncUWSettings.riskSurveyDetails.floor = data.floor
      state.specialFuncUWSettings.riskSurveyDetails.stairs = data.stairs
      state.specialFuncUWSettings.riskSurveyDetails.noOpen = data.noOpen
      state.specialFuncUWSettings.riskSurveyDetails.noFireChkDoor = data.noFireChkDoor
      state.specialFuncUWSettings.riskSurveyDetails.constnType = data.constnType
      state.specialFuncUWSettings.riskSurveyDetails.extn = data.extn
      state.specialFuncUWSettings.riskSurveyDetails.extnConstn = data.extnConstn
      state.specialFuncUWSettings.riskSurveyDetails.noUnitTerr = data.noUnitTerr
      state.specialFuncUWSettings.riskSurveyDetails.occpnTerr = data.occpnTerr
      state.specialFuncUWSettings.riskSurveyDetails.noUnitHr = data.noUnitHr
      state.specialFuncUWSettings.riskSurveyDetails.occpnHr = data.occpnHr
      state.specialFuncUWSettings.riskSurveyDetails.strataTitle = data.strataTitle
      state.specialFuncUWSettings.riskSurveyDetails.nearBldg = data.nearBldg
      state.specialFuncUWSettings.riskSurveyDetails.adjUnitOccpn = data.adjUnitOccpn
      state.specialFuncUWSettings.riskSurveyDetails.constnRemarks = data.constnRemarks
      state.specialFuncUWSettings.riskSurveyDetails.fencedUp = data.fencedUp
      state.specialFuncUWSettings.riskSurveyDetails.securGrd = data.securGrd
      state.specialFuncUWSettings.riskSurveyDetails.onSlope = data.onSlope
      state.specialFuncUWSettings.riskSurveyDetails.retStrc = data.retStrc
      state.specialFuncUWSettings.riskSurveyDetails.river = data.river
      state.specialFuncUWSettings.riskSurveyDetails.floodProne = data.floodProne
      state.specialFuncUWSettings.riskSurveyDetails.surrRemarks = data.surrRemarks
      state.specialFuncUWSettings.riskSurveyDetails.wiringType = data.wiringType
      state.specialFuncUWSettings.riskSurveyDetails.cbType = data.cbType
      state.specialFuncUWSettings.riskSurveyDetails.noGen = data.noGen
      state.specialFuncUWSettings.riskSurveyDetails.ltgRemarks = data.ltgRemarks
      state.specialFuncUWSettings.riskSurveyDetails.extType = data.extType
      state.specialFuncUWSettings.riskSurveyDetails.noExt = data.noExt
      state.specialFuncUWSettings.riskSurveyDetails.inspDate = data.inspDate
      state.specialFuncUWSettings.riskSurveyDetails.noHoseReel = data.noHoseReel
      state.specialFuncUWSettings.riskSurveyDetails.spr = data.spr
      state.specialFuncUWSettings.riskSurveyDetails.smokeDet = data.smokeDet
      state.specialFuncUWSettings.riskSurveyDetails.fireAlrm = data.fireAlrm
      state.specialFuncUWSettings.riskSurveyDetails.dryRiser = data.dryRiser
      state.specialFuncUWSettings.riskSurveyDetails.wetRiser = data.wetRiser
      state.specialFuncUWSettings.riskSurveyDetails.hydrant = data.hydrant
      state.specialFuncUWSettings.riskSurveyDetails.fireDrill = data.fireDrill
      state.specialFuncUWSettings.riskSurveyDetails.nearFireSt = data.nearFireSt
      state.specialFuncUWSettings.riskSurveyDetails.firePrevRemarks = data.firePrevRemarks
      state.specialFuncUWSettings.riskSurveyDetails.clean = data.clean
      state.specialFuncUWSettings.riskSurveyDetails.layout = data.layout
      state.specialFuncUWSettings.riskSurveyDetails.vent = data.vent
      state.specialFuncUWSettings.riskSurveyDetails.smokeReg = data.smokeReg
      state.specialFuncUWSettings.riskSurveyDetails.wasteDisp = data.wasteDisp
      state.specialFuncUWSettings.riskSurveyDetails.wasteDispFreq = data.wasteDispFreq
      state.specialFuncUWSettings.riskSurveyDetails.mgmtRemarks = data.mgmtRemarks
      state.specialFuncUWSettings.riskSurveyDetails.insdBldg = data.insdBldg
      state.specialFuncUWSettings.riskSurveyDetails.insdCont = data.insdCont
      state.specialFuncUWSettings.riskSurveyDetails.insdPlt = data.insdPlt
      state.specialFuncUWSettings.riskSurveyDetails.insdRawMat = data.insdRawMat
      state.specialFuncUWSettings.riskSurveyDetails.insdGoods = data.insdGoods
      state.specialFuncUWSettings.riskSurveyDetails.insdPackMat = data.insdPackMat
      state.specialFuncUWSettings.riskSurveyDetails.occpnCls = data.occpnCls
      state.specialFuncUWSettings.riskSurveyDetails.goodsType = data.goodsType
      state.specialFuncUWSettings.riskSurveyDetails.goodsFlam = data.goodsFlam
      state.specialFuncUWSettings.riskSurveyDetails.packType = data.packType
      state.specialFuncUWSettings.riskSurveyDetails.storeArr = data.storeArr
      state.specialFuncUWSettings.riskSurveyDetails.stacksHgt = data.stacksHgt
      state.specialFuncUWSettings.riskSurveyDetails.whsType = data.whsType
      state.specialFuncUWSettings.riskSurveyDetails.othTent = data.othTent
      state.specialFuncUWSettings.riskSurveyDetails.part = data.part
      state.specialFuncUWSettings.riskSurveyDetails.partType = data.partType
      state.specialFuncUWSettings.riskSurveyDetails.othTentGoods = data.othTentGoods
      state.specialFuncUWSettings.riskSurveyDetails.occpnRemarks = data.occpnRemarks
      state.specialFuncUWSettings.riskSurveyDetails.fireAttchRemarks = data.fireAttchRemarks
      state.specialFuncUWSettings.riskSurveyDetails.stkType = data.stkType
      state.specialFuncUWSettings.riskSurveyDetails.stkVal = data.stkVal
      state.specialFuncUWSettings.riskSurveyDetails.highVal = data.highVal
      state.specialFuncUWSettings.riskSurveyDetails.invRec = data.invRec
      state.specialFuncUWSettings.riskSurveyDetails.onPrem = data.onPrem
      state.specialFuncUWSettings.riskSurveyDetails.noOnPrem = data.noOnPrem
      state.specialFuncUWSettings.riskSurveyDetails.hrsEmpty = data.hrsEmpty
      state.specialFuncUWSettings.riskSurveyDetails.alrmType = data.alrmType
      state.specialFuncUWSettings.riskSurveyDetails.alrmConn = data.alrmConn
      state.specialFuncUWSettings.riskSurveyDetails.wtchmen = data.wtchmen
      state.specialFuncUWSettings.riskSurveyDetails.wtchmenArmd = data.wtchmenArmd
      state.specialFuncUWSettings.riskSurveyDetails.wtchmenHrs = data.wtchmenHrs
      state.specialFuncUWSettings.riskSurveyDetails.premRemarks = data.premRemarks
      state.specialFuncUWSettings.riskSurveyDetails.mainEntDrMat = data.mainEntDrMat
      state.specialFuncUWSettings.riskSurveyDetails.mainEntProt = data.mainEntProt
      state.specialFuncUWSettings.riskSurveyDetails.mainEntLock = data.mainEntLock
      state.specialFuncUWSettings.riskSurveyDetails.othEntDrMat = data.othEntDrMat
      state.specialFuncUWSettings.riskSurveyDetails.othEntProt = data.othEntProt
      state.specialFuncUWSettings.riskSurveyDetails.othEntLock = data.othEntLock
      state.specialFuncUWSettings.riskSurveyDetails.windMat = data.windMat
      state.specialFuncUWSettings.riskSurveyDetails.windProt = data.windProt
      state.specialFuncUWSettings.riskSurveyDetails.windLock = data.windLock
      state.specialFuncUWSettings.riskSurveyDetails.entRemarks = data.entRemarks
      state.specialFuncUWSettings.riskSurveyDetails.safeMake = data.safeMake
      state.specialFuncUWSettings.riskSurveyDetails.safeDim = data.safeDim
      state.specialFuncUWSettings.riskSurveyDetails.safeLock = data.safeLock
      state.specialFuncUWSettings.riskSurveyDetails.safeConcld = data.safeConcld
      state.specialFuncUWSettings.riskSurveyDetails.lossRemarks = data.lossRemarks
      state.specialFuncUWSettings.riskSurveyDetails.remarks = data.remarks
      state.specialFuncUWSettings.riskSurveyDetails.burgRemarks = data.burgRemarks
    }
  },
  [RESET_RISK_SURVEY_MASTER](state, data) {
    state.specialFuncUWSettings.riskSurveyMaster.survNo = null
    state.specialFuncUWSettings.riskSurveyMaster.verCnt = 0
    state.specialFuncUWSettings.riskSurveyMaster.survId = undefined
    state.specialFuncUWSettings.riskSurveyMaster.survDate = new Date()
    state.specialFuncUWSettings.riskSurveyMaster.polNo = undefined
    state.specialFuncUWSettings.riskSurveyMaster.insdName = undefined
    state.specialFuncUWSettings.riskSurveyMaster.bldgNo = undefined
    state.specialFuncUWSettings.riskSurveyMaster.unitNo = undefined
    state.specialFuncUWSettings.riskSurveyMaster.addr1 = undefined
    state.specialFuncUWSettings.riskSurveyMaster.addr2 = undefined
    state.specialFuncUWSettings.riskSurveyMaster.addr3 = undefined
    state.specialFuncUWSettings.riskSurveyMaster.addr4 = undefined
    state.specialFuncUWSettings.riskSurveyMaster.postCode = undefined
    state.specialFuncUWSettings.riskSurveyMaster.survType = undefined
    state.specialFuncUWSettings.riskSurveyMaster.extPhoto = false
    state.specialFuncUWSettings.riskSurveyMaster.intPhoto = false
    state.specialFuncUWSettings.riskSurveyMaster.plans = false
    state.specialFuncUWSettings.riskSurveyMaster.adjUnit = undefined
    state.specialFuncUWSettings.riskSurveyMaster.contactName = undefined
    state.specialFuncUWSettings.riskSurveyMaster.telNo = undefined
    state.specialFuncUWSettings.riskSurveyMaster.nxtSurvBy = undefined
    state.specialFuncUWSettings.riskSurveyMaster.updDate = undefined
    state.specialFuncUWSettings.riskSurveyMaster.recomComp = undefined
    state.specialFuncUWSettings.riskSurveyMaster.remarks = undefined
    state.specialFuncUWSettings.riskSurveyMaster.uwIdConv = undefined
    state.specialFuncUWSettings.riskSurveyMaster.nxtSurvDate = undefined
  },
  [RESET_RISK_SURVEY_DETAILS](state, data) {
    state.specialFuncUWSettings.riskSurveyDetails.survNo = null
    state.specialFuncUWSettings.riskSurveyDetails.verCnt = 0
    state.specialFuncUWSettings.riskSurveyDetails.survDetType = undefined
    state.specialFuncUWSettings.riskSurveyDetails.constnCls = undefined
    state.specialFuncUWSettings.riskSurveyDetails.yrBlt = undefined
    state.specialFuncUWSettings.riskSurveyDetails.preWar = false
    state.specialFuncUWSettings.riskSurveyDetails.refurbish = false
    state.specialFuncUWSettings.riskSurveyDetails.wall = undefined
    state.specialFuncUWSettings.riskSurveyDetails.roof = undefined
    state.specialFuncUWSettings.riskSurveyDetails.floor = undefined
    state.specialFuncUWSettings.riskSurveyDetails.stairs = undefined
    state.specialFuncUWSettings.riskSurveyDetails.noOpen = undefined
    state.specialFuncUWSettings.riskSurveyDetails.noFireChkDoor = undefined
    state.specialFuncUWSettings.riskSurveyDetails.constnType = undefined
    state.specialFuncUWSettings.riskSurveyDetails.extn = false
    state.specialFuncUWSettings.riskSurveyDetails.extnConstn = undefined
    state.specialFuncUWSettings.riskSurveyDetails.noUnitTerr = undefined
    state.specialFuncUWSettings.riskSurveyDetails.occpnTerr = undefined
    state.specialFuncUWSettings.riskSurveyDetails.noUnitHr = undefined
    state.specialFuncUWSettings.riskSurveyDetails.occpnHr = undefined
    state.specialFuncUWSettings.riskSurveyDetails.strataTitle = undefined
    state.specialFuncUWSettings.riskSurveyDetails.nearBldg = undefined
    state.specialFuncUWSettings.riskSurveyDetails.adjUnitOccpn = undefined
    state.specialFuncUWSettings.riskSurveyDetails.constnRemarks = undefined
    state.specialFuncUWSettings.riskSurveyDetails.fencedUp = false
    state.specialFuncUWSettings.riskSurveyDetails.securGrd = false
    state.specialFuncUWSettings.riskSurveyDetails.onSlope = false
    state.specialFuncUWSettings.riskSurveyDetails.retStrc = false
    state.specialFuncUWSettings.riskSurveyDetails.river = false
    state.specialFuncUWSettings.riskSurveyDetails.floodProne = false
    state.specialFuncUWSettings.riskSurveyDetails.surrRemarks = undefined
    state.specialFuncUWSettings.riskSurveyDetails.wiringType = undefined
    state.specialFuncUWSettings.riskSurveyDetails.cbType = undefined
    state.specialFuncUWSettings.riskSurveyDetails.noGen = undefined
    state.specialFuncUWSettings.riskSurveyDetails.ltgRemarks = undefined
    state.specialFuncUWSettings.riskSurveyDetails.extType = undefined
    state.specialFuncUWSettings.riskSurveyDetails.noExt = undefined
    state.specialFuncUWSettings.riskSurveyDetails.inspDate = undefined
    state.specialFuncUWSettings.riskSurveyDetails.noHoseReel = undefined
    state.specialFuncUWSettings.riskSurveyDetails.spr = false
    state.specialFuncUWSettings.riskSurveyDetails.smokeDet = false
    state.specialFuncUWSettings.riskSurveyDetails.fireAlrm = false
    state.specialFuncUWSettings.riskSurveyDetails.dryRiser = false
    state.specialFuncUWSettings.riskSurveyDetails.wetRiser = false
    state.specialFuncUWSettings.riskSurveyDetails.hydrant = false
    state.specialFuncUWSettings.riskSurveyDetails.fireDrill = false
    state.specialFuncUWSettings.riskSurveyDetails.nearFireSt = undefined
    state.specialFuncUWSettings.riskSurveyDetails.firePrevRemarks = undefined
    state.specialFuncUWSettings.riskSurveyDetails.clean = undefined
    state.specialFuncUWSettings.riskSurveyDetails.layout = undefined
    state.specialFuncUWSettings.riskSurveyDetails.vent = undefined
    state.specialFuncUWSettings.riskSurveyDetails.smokeReg = false
    state.specialFuncUWSettings.riskSurveyDetails.wasteDisp = undefined
    state.specialFuncUWSettings.riskSurveyDetails.wasteDispFreq = undefined
    state.specialFuncUWSettings.riskSurveyDetails.mgmtRemarks = undefined
    state.specialFuncUWSettings.riskSurveyDetails.insdBldg = 0
    state.specialFuncUWSettings.riskSurveyDetails.insdCont = 0
    state.specialFuncUWSettings.riskSurveyDetails.insdPlt = 0
    state.specialFuncUWSettings.riskSurveyDetails.insdRawMat = 0
    state.specialFuncUWSettings.riskSurveyDetails.insdGoods = 0
    state.specialFuncUWSettings.riskSurveyDetails.insdPackMat = 0
    state.specialFuncUWSettings.riskSurveyDetails.occpnCls = undefined
    state.specialFuncUWSettings.riskSurveyDetails.goodsType = undefined
    state.specialFuncUWSettings.riskSurveyDetails.goodsFlam = undefined
    state.specialFuncUWSettings.riskSurveyDetails.packType = undefined
    state.specialFuncUWSettings.riskSurveyDetails.storeArr = undefined
    state.specialFuncUWSettings.riskSurveyDetails.stacksHgt = undefined
    state.specialFuncUWSettings.riskSurveyDetails.whsType = undefined
    state.specialFuncUWSettings.riskSurveyDetails.othTent = false
    state.specialFuncUWSettings.riskSurveyDetails.part = false
    state.specialFuncUWSettings.riskSurveyDetails.partType = undefined
    state.specialFuncUWSettings.riskSurveyDetails.othTentGoods = undefined
    state.specialFuncUWSettings.riskSurveyDetails.occpnRemarks = undefined
    state.specialFuncUWSettings.riskSurveyDetails.fireAttchRemarks = undefined
    state.specialFuncUWSettings.riskSurveyDetails.stkType = undefined
    state.specialFuncUWSettings.riskSurveyDetails.stkVal = 0
    state.specialFuncUWSettings.riskSurveyDetails.highVal = 0
    state.specialFuncUWSettings.riskSurveyDetails.invRec = undefined
    state.specialFuncUWSettings.riskSurveyDetails.onPrem = false
    state.specialFuncUWSettings.riskSurveyDetails.noOnPrem = undefined
    state.specialFuncUWSettings.riskSurveyDetails.hrsEmpty = undefined
    state.specialFuncUWSettings.riskSurveyDetails.alrmType = undefined
    state.specialFuncUWSettings.riskSurveyDetails.alrmConn = undefined
    state.specialFuncUWSettings.riskSurveyDetails.wtchmen = false
    state.specialFuncUWSettings.riskSurveyDetails.wtchmenArmd = false
    state.specialFuncUWSettings.riskSurveyDetails.wtchmenHrs = undefined
    state.specialFuncUWSettings.riskSurveyDetails.premRemarks = undefined
    state.specialFuncUWSettings.riskSurveyDetails.mainEntDrMat = undefined
    state.specialFuncUWSettings.riskSurveyDetails.mainEntProt = undefined
    state.specialFuncUWSettings.riskSurveyDetails.mainEntLock = undefined
    state.specialFuncUWSettings.riskSurveyDetails.othEntDrMat = undefined
    state.specialFuncUWSettings.riskSurveyDetails.othEntProt = undefined
    state.specialFuncUWSettings.riskSurveyDetails.othEntLock = undefined
    state.specialFuncUWSettings.riskSurveyDetails.windMat = undefined
    state.specialFuncUWSettings.riskSurveyDetails.windProt = undefined
    state.specialFuncUWSettings.riskSurveyDetails.windLock = undefined
    state.specialFuncUWSettings.riskSurveyDetails.entRemarks = undefined
    state.specialFuncUWSettings.riskSurveyDetails.safeMake = undefined
    state.specialFuncUWSettings.riskSurveyDetails.safeDim = undefined
    state.specialFuncUWSettings.riskSurveyDetails.safeLock = undefined
    state.specialFuncUWSettings.riskSurveyDetails.safeConcld = false
    state.specialFuncUWSettings.riskSurveyDetails.lossRemarks = undefined
    state.specialFuncUWSettings.riskSurveyDetails.remarks = undefined
    state.specialFuncUWSettings.riskSurveyDetails.burgRemarks = undefined
  }
}
